import { useEffect, useRef } from 'react';
import { useAsyncResource } from '@hooks';
import { fetchReportPdf } from '@/entities/io/pdf.api';
import styles from './PdfPreview.module.css';

function PdfFrame({ blob, title }) {
  const frame = useRef(null);
  useEffect(() => {
    const element = frame.current;
    const objectUrl = URL.createObjectURL(blob);
    element.src = objectUrl;
    return () => {
      element.removeAttribute('src');
      URL.revokeObjectURL(objectUrl);
    };
  }, [blob]);
  return <iframe ref={frame} className={styles.frame} title={title} />;
}

function PdfResource({ url, title }) {
  const controller = useRef(null);
  useEffect(() => () => controller.current?.abort(), []);
  const resource = useAsyncResource(async () => {
    controller.current?.abort();
    const request = new AbortController();
    controller.current = request;
    return fetchReportPdf(url, { signal: request.signal });
  }, [url], { initialData: null });

  if (resource.isLoading) return <p className={styles.message} role="status">Downloading PDF preview…</p>;
  if (resource.error) return <div className={styles.feedback}>
    <p role="alert">{resource.error}</p>
    <p>The report can still be opened using the link above.</p>
    <button type="button" className={styles.button} onClick={() => resource.reload()}>Retry preview</button>
  </div>;
  return resource.data ? <PdfFrame blob={resource.data} title={title} /> : null;
}

export default function PdfPreview({ url, title }) {
  return <PdfResource key={url} url={url} title={title} />;
}